/**
 * Insights Service
 * Fetches parent dashboard insights for a child
 */

import { apiClient, extractData } from './api';
import type { ParentInsights } from '@kids-lms/types';

export async function getParentInsights(childId: string): Promise<ParentInsights> {
  const response = await apiClient.get<{ success: boolean; data: ParentInsights }>(
    `/insights/${childId}`
  );
  return extractData(response);
}
